import { showError } from '@builder/core/utilities';

// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';

class RecipeNotices {
	constructor() {
		// Check if error mode is enabled
		if ( UncannyAutomator.recipe.errorMode ) {
			// Create error
			this.createError();
		}
	}

	createError() {
		// Check if we have to create the notice
		if ( ! _uo.utility.isEmpty( UncannyAutomator.recipe.message.error ) ) {
			showError( UncannyAutomator.recipe.message.error );
		}
	}
}

export default RecipeNotices;
